import { render } from "./Disability.vue?vue&type=template&id=30cb96b4&scoped=true&ts=true"
import script from "./Disability.vue?vue&type=script&lang=ts"
export * from "./Disability.vue?vue&type=script&lang=ts"

import "./Disability.vue?vue&type=style&index=0&id=30cb96b4&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cb96b4"]])

export default __exports__